import LongAnswerQuestions from "./longAnswer";
import CaseStudySection from "./caseStudy";
import { ExamSectionEnum } from "../../../utils/enums/exam";
import { Question, Section } from "../../../utils/interface/exam";
import McqQuestions from "./mcq";
import VeryShortAnswerQuestions from "./vsa";
import ShortAnswerQuestions from "./sa";


const sectionPair = [
    {
        type: ExamSectionEnum.MCQ,
        componet: (question: Question) => <McqQuestions question={question} />
    },
    {
        type: ExamSectionEnum.VSA,
        componet: (question: Question) => <VeryShortAnswerQuestions question={question} />
    },
    {
        type: ExamSectionEnum.LA,
        componet: (question: Question) => <LongAnswerQuestions question={question} />
    },
    {
        type: ExamSectionEnum.SA,
        componet: (question: Question) => <ShortAnswerQuestions question={question} />
    },
    {
        type: ExamSectionEnum.CS,
        componet: (question: Question) => <CaseStudySection question={question} />
    }
]


interface ExamSectionProps {
    section: Section;
}

export const ExamSection = (props: ExamSectionProps) => {

    try {
        const { section } = props;

        const type = sectionPair.find(pair => pair.type === section.type)

        if (type) {
            try {
                return (
                    <>
                        {section.questions.map((question) => (type?.componet(question)))}
                    </>
                )
            } catch (error) {
                return <></>
            }

        }
    } catch (error) {
        return <></>
    }



    return <></>
}